var _path, _line;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgRefund(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 21,
    viewBox: "0 0 26 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4 10.9869C4 16.1173 8.10434 20.2217 13.2348 20.2217C19.9043 20.2217 25.0347 13.0391 21.033 6.06173C15.8 -1.83912 4 1.85477 4 10.9869ZM16.313 7.90867H12.2087C10.8748 7.90867 10.8748 9.96084 12.2087 9.96084H14.2608C16.0052 9.96084 17.3391 11.2947 17.3391 13.0391C17.3391 14.6808 16.0052 16.1173 14.2608 16.1173V17.1434C14.2608 18.4773 12.2087 18.4773 12.2087 17.1434V16.1173H10.1565C8.8226 16.1173 8.8226 14.0652 10.1565 14.0652H14.2608C15.5948 14.0652 15.5948 12.013 14.2608 12.013H12.2087C10.4643 12.013 9.13042 10.5765 9.13042 8.93475C9.13042 7.19041 10.4643 5.8565 12.2087 5.8565V4.83042C12.2087 3.49651 14.2608 3.49651 14.2608 4.83042V5.8565H16.313C17.6469 5.8565 17.6469 7.90867 16.313 7.90867Z",
    fill: "#2F2F2F"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 2.2,
    y1: 18.5351,
    x2: 24.6,
    y2: 1.73506,
    stroke: "#2F2F2F",
    strokeWidth: 2,
    strokeLinecap: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRefund);
export default __webpack_public_path__ + "static/media/refund.30cb0191ac68137ec7197d2c35fbf672.svg";
export { ForwardRef as ReactComponent };